namespace ibHeaderMainPageNameSpace {
    const ibHeaderMainPageConstants = {
        languages: {
            de: [{ code: 'es', description: 'Español' }, { code: 'de', description: 'Deutsch' }],
            dz: [{ code: 'es', description: 'Español' }, { code: 'fr', description: 'Français' }],
            ar: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            at: [{ code: 'es', description: 'Español' }, { code: 'de', description: 'Deutsch' }],
            br: [{ code: 'es', description: 'Español' }, { code: 'pt', description: 'Português' }],
            be: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }, { code: 'fr', description: 'Français' }],
            cl: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            cn: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }, { code: 'zh', description: '中国' }],
            co: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            cr: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            cu: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            dk: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            ec: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            sv: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            es: [{ code: 'es', description: 'Español' }, { code: 'ca', description: 'Catalá' }, { code: 'en', description: 'English' }],
            fi: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            fr: [{ code: 'es', description: 'Español' }, { code: 'fr', description: 'Français' }],
            gr: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            gt: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            gq: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            nl: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }, { code: 'nl', description: 'Nederlands' }],
            hu: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            ie: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            il: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            it: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }, { code: 'it', description: 'Italiano' }],
            jp: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }, { code: 'ja', description: '日本の' }],
            ma: [{ code: 'es', description: 'Español' }, { code: 'fr', description: 'Français' }],
            mx: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            pa: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            pe: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            pt: [{ code: 'es', description: 'Español' }, { code: 'pt', description: 'Português' }],
            pr: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            gb: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            cz: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            do: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            ru: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }, { code: 'ru', description: 'Pусский' }],
            sn: [{ code: 'es', description: 'Español' }, { code: 'fr', description: 'Français' }],
            za: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            se: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            ch: [{ code: 'es', description: 'Español' }, { code: 'de', description: 'Deutsch' }, { code: 'fr', description: 'Français' }],
            tr: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            us: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            uy: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            ve: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }]
        },
        markets: [
            { code: 'AO', description: 'Angola' },
            { code: 'AR', description: 'Argentina' },
            { code: 'BE', description: 'Belgique' },
            { code: 'BR', description: 'Brasil' },
            { code: 'CL', description: 'Chile' },
            { code: 'CN', description: 'China' },
            { code: 'CO', description: 'Colombia' },
            { code: 'CR', description: 'Costa Rica' },
            { code: 'HR', description: 'Croazia' },
            { code: 'CU', description: 'Cuba' },
            { code: 'CZ', description: 'Czech Republic' },
            { code: 'DK', description: 'Denmark' },
            { code: 'DE', description: 'Deutschland' },
            { code: 'EC', description: 'Ecuador' },
            { code: 'SV', description: 'El Salvador' },
            { code: 'GQ', description: 'Equatorial Guinea' },
            { code: 'ES', description: 'España' },
            { code: 'FI', description: 'Finland' },
            { code: 'FR', description: 'France' },
            { code: 'GH', description: 'Ghana' },
            { code: 'GR', description: 'Greece' },
            { code: 'GT', description: 'Guatemala' },
            { code: 'NL', description: 'Holland' },
            { code: 'HN', description: 'Honduras' },
            { code: 'HU', description: 'Hungary' },
            { code: 'IE', description: 'Ireland' },
            { code: 'IL', description: 'Israel' },
            { code: 'IT', description: 'Italia' },
            { code: 'JP', description: 'Japón' },
            { code: 'MT', description: 'Malta' },
            { code: 'MA', description: 'Maroc' },
            { code: 'MR', description: 'Mauritanie' },
            { code: 'MX', description: 'México' },
            { code: 'NI', description: 'Nicaragua' },
            { code: 'NG', description: 'Nigeria' },
            { code: 'PA', description: 'Panamá' },
            { code: 'PE', description: 'Perú' },
            { code: 'PT', description: 'Portugal' },
            { code: 'PR', description: 'Puerto Rico' },
            { code: 'DO', description: 'República Dominicana' },
            { code: 'CH', description: 'Schweiz' },
            { code: 'ZA', description: 'South Africa' },
            { code: 'SE', description: 'Sweden' },
            { code: 'SN', description: 'Sénégal' },
            { code: 'TR', description: 'Turkey' },
            { code: 'US', description: 'USA' },
            { code: 'GB', description: 'United Kingdom' },
            { code: 'UY', description: 'Uruguay' },
            { code: 'VE', description: 'Venezuela' },
            { code: 'AT', description: 'Österreich' },
            { code: 'RU', description: 'Россия' },
            { code: 'DZ', description: 'Algérie' }
        ],
        languagesWcs: {
            dz: [{ code: 'fr', description: 'Français' }, { code: 'es', description: 'Español' }],
            ar: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            be: [{ code: 'fr', description: 'Français' }, { code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            br: [{ code: 'pt', description: 'Português' }, { code: 'es', description: 'Español' }],            
            cl: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            co: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            cr: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            cu: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            cz: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            dk: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            de: [{ code: 'de', description: 'Deutsch' }, { code: 'es', description: 'Español' }],
            ec: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            sv: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            es: [{ code: 'es', description: 'Español' }, { code: 'ca', description: 'Catalá' }, { code: 'en', description: 'English' }],
            fi: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            fr: [{ code: 'fr', description: 'Français' }, { code: 'es', description: 'Español' }],
            gr: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            gt: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            hu: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            ie: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            il: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            it: [{ code: 'it', description: 'Italiano' }, { code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            ma: [{ code: 'fr', description: 'Français' }, { code: 'es', description: 'Español' }],
            mx: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            nl: [{ code: 'nl', description: 'Nederlands' }, { code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            at: [{ code: 'de', description: 'Deutsch' }, { code: 'es', description: 'Español' }],
            pa: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            pe: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            pt: [{ code: 'pt', description: 'Português' }, { code: 'es', description: 'Español' }],
            pr: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            do: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            ch: [{ code: 'de', description: 'Deutsch' }, { code: 'es', description: 'Español' }, { code: 'fr', description: 'Français' }],
            sn: [{ code: 'fr', description: 'Français' }, { code: 'es', description: 'Español' }],
            se: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            gb: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            uy: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            us: [{ code: 'en', description: 'English' }, { code: 'es', description: 'Español' }],
            ve: [{ code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            ru: [{ code: 'ru', description: 'Pусский' }, { code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            cn: [{ code: 'zh', description: '中国' }, { code: 'es', description: 'Español' }, { code: 'en', description: 'English' }],
            jp: [{ code: 'ja', description: '日本の' }, { code: 'es', description: 'Español' }, { code: 'en', description: 'English' }]
        },
        marketsWcs : [
            { code: 'DZ', description: 'Algérie' },
            { code: 'AR', description: 'Argentina' },
            { code: 'BE', description: 'Belgique' },
            { code: 'BR', description: 'Brasil' },
            { code: 'CL', description: 'Chile' },
            { code: 'CO', description: 'Colombia' },
            { code: 'CR', description: 'Costa Rica' },            
            { code: 'CU', description: 'Cuba' },
            { code: 'CZ', description: 'Czech Republic' },
            { code: 'DK', description: 'Denmark' },
            { code: 'DE', description: 'Deutschland' },
            { code: 'EC', description: 'Ecuador' },
            { code: 'SV', description: 'El Salvador' },
            { code: 'ES', description: 'España' },
            { code: 'FI', description: 'Finland' },
            { code: 'FR', description: 'France' },
            { code: 'GR', description: 'Greece' },
            { code: 'GT', description: 'Guatemala' },
            { code: 'HU', description: 'Hungary' },
            { code: 'IE', description: 'Ireland' },
            { code: 'IL', description: 'Israel' },
            { code: 'IT', description: 'Italia' },
            { code: 'MA', description: 'Maroc' },
            { code: 'MX', description: 'México' },
            { code: 'NL', description: 'Netherlands' },
            { code: 'AT', description: 'Österreich' },
            { code: 'PA', description: 'Panamá' },
            { code: 'PE', description: 'Perú' },
            { code: 'PT', description: 'Portugal' },
            { code: 'PR', description: 'Puerto Rico' },
            { code: 'DO', description: 'República Dominicana' },
            { code: 'CH', description: 'Schweiz' },
            { code: 'SN', description: 'Sénégal' },
            { code: 'SE', description: 'Sweden' },
            { code: 'GB', description: 'United Kingdom' },
            { code: 'UY', description: 'Uruguay' },
            { code: 'US', description: 'USA' },
            { code: 'VE', description: 'Venezuela' },
            { code: 'RU', description: 'Россия' },
            { code: 'CN', description: '中国' },
            { code: 'JP', description: '日本' }
        ]
    };
    try {
        const mod = angular.module('ib-header-main-page-component-module');

        mod.constant(
            'ibHeaderMainPageConstants', ibHeaderMainPageConstants
        );
    } catch (error) {
        const mod = angular.module('ib-header-main-page-component-module', []);
        mod.constant(
            'ibHeaderMainPageConstants', ibHeaderMainPageConstants
        );
    }
    export type ibHeaderMainPageConstants = typeof ibHeaderMainPageConstants;
}
